import { getCurrentInstance, inject, InjectionKey } from 'vue';

export class NotResolvedInjectError extends Error {
  name = 'NotResolvedInjectError';
}

/**
 * Метод позволяет использовать зависимость (средствами стандартного `inject`)
 *
 * @param serviceName
 * @param defaultValue
 * @param {boolean} stop - генерировать исключение при отсутствии зависимости
 * @param treatDefaultAsFactory
 * @returns {any}
 */
export const resolveService = <T = any>(
  serviceName: string | symbol | InjectionKey<T>,
  defaultValue: T | (() => T) = null as unknown as T,
  stop: boolean = false,
  treatDefaultAsFactory: boolean = false
): T => {
  if (process.env.NODE_ENV === 'development') {
    console.debug(`Resolving "${String(serviceName)}" ...`);
  }
  let defaultWasUsed = false;
  const resolvedInject = inject<T>(
    serviceName,
    () => {
      // eslint-disable-next-line no-underscore-dangle
      const componentName = getCurrentInstance()?.type.__name || 'Unknown component';
      const message = `You didn't provide "${String(
        serviceName
      )}", which is needed in "${componentName}" component! \n Did you forget ot add \`app.provide('${String(
        serviceName
      )}', PLACE_YOUR_VALUE_HERE)\` somewhere in boot file?`;
      if (stop) {
        throw new NotResolvedInjectError(message);
      } else {
        console.error(message);
      }
      defaultWasUsed = true;
      return typeof defaultValue === 'function' && treatDefaultAsFactory
        ? (defaultValue as CallableFunction)()
        : defaultValue;
    },
    true
  );
  if (process.env.NODE_ENV === 'development' && !defaultWasUsed) {
    console.debug(`"${String(serviceName)}" was successfully resolved: `, resolvedInject);
  }
  return resolvedInject;
};
